import { IRoleTypeService } from "../../service/role/RoleTypeService";
import { IRoleType } from "../../model/role/RoleType";

export default class UpdateRoleTypeInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }

  async execute(roleType: IRoleType) {
    return this.roleTypeService.updateRoleType(roleType);
  }
}
